import axios from "axios";
import Config from "../../../config";

const v2_actionGetInviteLink = (chatId) => axios({
    method: "get",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/invite-link`
});

export default v2_actionGetInviteLink;
